import { useCallback } from 'react'
import useVehicleController from '../../../../../../../controllers/vehicle.controller'

const useHandleAddVehicle = param => {
  const {
    product,
  } = param

  const { updateVehicles } = useVehicleController()

  return useCallback(
    () => {
      const rootElem = document.getElementById('topMostDiv')
      if (rootElem && rootElem.scrollIntoView) {
        rootElem.scrollIntoView({
          behavior: 'smooth',
        })
      }

      updateVehicles({
        showVehicleSelector: true,
        overlay: true,
        cartVehicleDB: { itemId: product.productId },
      })
    },
    [product, updateVehicles],
  )
}

export default useHandleAddVehicle
